'use es6';

import DSContext from './DSContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default (Component => {
  const ComponentWithContext = props => /*#__PURE__*/_jsx(DSContext.Consumer, {
    children: context => /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      DSData: context
    }))
  });
  ComponentWithContext.WrappedComponent = Component;
  return ComponentWithContext;
});